import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { Segment, VerificationService, VerificationStep } from '../../lib/types/types';
import { FaqLinkComponent } from '../FaqLink/FaqLinkComponent';
import { assertValidSegmentName } from '../../lib/types/assertions';
import { SegmentEnum, VerificationStepsEnum } from '../../lib/types/runtimeTypes';
import { howDoesVerifyingWorkMessages } from './HowDoesVerifyingWorkMessages';
import { getCompanyName } from '../../lib/ProgramTheme/programThemeGetters';

interface HowDoesVerifyingWorkProps {
    verificationService: VerificationService;
}

interface HowDoesVerifyingWorkState {
    tooltipIsOpen: boolean;
}

export class HowDoesVerifyingWorkComponent extends React.Component<HowDoesVerifyingWorkProps, HowDoesVerifyingWorkState> {

    private getDefaultDetailsMessage = (step: VerificationStep, segment: Segment):string => {
        const isDocUpload = step === VerificationStepsEnum.docUpload;
        const messages = howDoesVerifyingWorkMessages();
        assertValidSegmentName(segment);
        switch (segment) {
            case SegmentEnum.STUDENT:
                return isDocUpload ? messages.docUploadStudent : messages.defaultStudent;

            case SegmentEnum.TEACHER:
                return isDocUpload ? messages.docUploadTeacher : messages.defaultTeacher;

            case SegmentEnum.MILITARY:
                return isDocUpload ? messages.docUploadMilitary : messages.defaultMilitary;

            case SegmentEnum.SENIOR:
                return isDocUpload ? messages.docUploadSenior : messages.defaultSenior;

            case SegmentEnum.FIRST_RESPONDER:
                return isDocUpload ? messages.docUploadFirstResponder : messages.defaultFirstResponder;

            case SegmentEnum.MEDICAL:
                return isDocUpload ? messages.docUploadMedical : messages.defaultMedical;

            default:
                return '-';
        }
    }

    constructor(props: HowDoesVerifyingWorkProps) {
        super(props);
        this.state = {
            tooltipIsOpen: false,
        };
        this.showTooltip = this.showTooltip.bind(this);
        this.hideTooltip = this.hideTooltip.bind(this);
    }

    showTooltip() {
        this.setState({
            tooltipIsOpen: true,
        });
    }

    hideTooltip() {
        this.setState({
            tooltipIsOpen: false,
        });
    }

    public render() {
        const segment = this.props.verificationService.verificationResponse.segment;
        const step = this.props.verificationService.verificationResponse.currentStep;
        const defaultMessage = `${this.getDefaultDetailsMessage(step, segment)}`;
        return (
            <div className="sid-how-verify-works" onMouseEnter={this.showTooltip} onMouseLeave={this.hideTooltip}>
                <span className="sid-link">
                    <FormattedHTMLMessage id="howDoesVerifyingWork"
                        defaultMessage="How does verifying work?" />
                </span>
                {
                    this.state.tooltipIsOpen ?
                        <div className="sid-how-verify-works__container">
                            <div className="sid-how-verify-works__caret" />
                            <div className="sid-how-verify-works__tooltip">
                                <FormattedHTMLMessage
                                    id={`step.${step === VerificationStepsEnum.docUpload ? 'docUpload' : 'personalInfo'}.howDoesVerifyingWorkDetails`}
                                    defaultMessage={defaultMessage}
                                    values={{
                                        companyName: getCompanyName(this.props.verificationService.programTheme),
                                    }} />
                                &nbsp;
                                <FaqLinkComponent verificationService={this.props.verificationService} />
                            </div>
                        </div>
                        :
                        null
                }
            </div>
        );
    }
}
